import { render, staticRenderFns } from "./MultiMessageArchive.vue?vue&type=template&id=87b4b8cc&scoped=true&"
import script from "./MultiMessageArchive.vue?vue&type=script&lang=js&"
export * from "./MultiMessageArchive.vue?vue&type=script&lang=js&"
import style0 from "./MultiMessageArchive.vue?vue&type=style&index=0&id=87b4b8cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b4b8cc",
  null
  
)

export default component.exports